import { render, staticRenderFns } from "./PerfisBulkSelectActions.vue?vue&type=template&id=78ce1ac0&"
import script from "./PerfisBulkSelectActions.vue?vue&type=script&lang=js&"
export * from "./PerfisBulkSelectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports